function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 9.67472L10.8803 13.647C10.9543 13.6898 11.032 13.7207 11.1111 13.7403V21.4445L4.4907 17.5265C4.18655 17.3465 4 17.0193 4 16.6659V9.67472ZM20 9.56912V16.6659C20 17.0193 19.8134 17.3465 19.5093 17.5265L12.8889 21.4444V13.6728C12.905 13.6648 12.921 13.6562 12.9368 13.647L20 9.56912Z",
  fill: "#9593A0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.21613 7.74669C4.30017 7.64057 4.40624 7.55087 4.52991 7.48501L11.5299 3.75665C11.8238 3.60014 12.1762 3.60014 12.4701 3.75665L19.4701 7.48501C19.5654 7.53578 19.6503 7.60071 19.7227 7.67642L12.0479 12.1074C11.9975 12.1366 11.951 12.1699 11.9086 12.2068C11.8662 12.1699 11.8196 12.1366 11.7692 12.1074L4.21613 7.74669Z",
  fill: "#9593A0"
});

function SvgGalleryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryIcon);
export default __webpack_public_path__ + "static/media/galleryIcon.65fc4796.svg";
export { ForwardRef as ReactComponent };